import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import { isCurrentPathAnonymousBrandFlow } from '../config/brands.config'

export function usePreserveUTM() {
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search)
    const utmParams: Record<string, string> = {}

    urlParams.forEach((value, key) => {
      if (key.startsWith('utm_')) {
        utmParams[key] = value
      }
    })

    if (Object.keys(utmParams).length > 0) {
      sessionStorage.setItem('utmParams', JSON.stringify(utmParams))
    }
  }, [location.search])

  useEffect(() => {
    const storedParams = sessionStorage.getItem('utmParams')
    let utmParams: Record<string, string> = {}

    if (storedParams) {
      utmParams = JSON.parse(storedParams) as Record<string, string>
    }

    const currentSearchParams = new URLSearchParams(location.search)

    Object.entries(utmParams).forEach(([key, value]) => {
      if (!currentSearchParams.has(key)) {
        currentSearchParams.append(key, value)
      }
    })

    const nextSearch = `?${currentSearchParams.toString()}`

    // Funil whitelabel (Remederi/Vikura): só reescreve quando falta algum UTM
    // e preserva state/hash — o replace com string pura apagava o
    // fromSchedulingIdentification e o paciente caía de novo na tela de dados
    // da Consulta na Hora. Cannect mantém o comportamento original.
    if (isCurrentPathAnonymousBrandFlow()) {
      if (Object.keys(utmParams).length > 0 && nextSearch !== location.search) {
        history.replace({
          pathname: location.pathname,
          search: nextSearch,
          hash: location.hash,
          state: location.state
        })
      }
      return
    }

    if (Object.keys(utmParams).length > 0) {
      history.replace(`${location.pathname}?${currentSearchParams.toString()}`)
    }
  }, [location.pathname, location.search, history])
}
